'use client';

import { useAppDispatch, useAppSelector, useAppStore } from 'src/hooks/reduxHooks';
import { FC, useContext, useEffect } from 'react';
import { getCompareAction, getFavoritesAction } from '../../store/Product/action';
import { loadFromLocalStorage } from '../../utils/localStorageUtils';
import { defineCurrency } from '../../api/geolocation';
import { getSelectedLocaleAction } from '../../store/Locale/action';
import { LanguageContext } from '../../providers/LanguageProvider';
import { setSelectedLanguageAction } from '../../store/SelectedLanguage/action';

interface LocaleProps {}

export const Locale: FC<LocaleProps> = () => {
  const dispatch = useAppDispatch();

  const selectedLang = useAppSelector((rootState) => rootState.selectedLang);
  const { lang, texts } = useContext(LanguageContext);
  const selectedCurrency = useAppSelector((rootState) => rootState.currency.selectedCurrency);
  const store = useAppStore();

  useEffect(() => {
    dispatch(getFavoritesAction(loadFromLocalStorage('favoriteProducts') || []));
    dispatch(getCompareAction(loadFromLocalStorage('compareProducts') || []));
    defineCurrency(selectedCurrency, store);
    dispatch(setSelectedLanguageAction(lang));
  }, [dispatch, lang, selectedCurrency, store]);

  useEffect(() => {
    if (texts) {
      dispatch(getSelectedLocaleAction(texts));
      return;
    }
    async function selectLocale() {
      let texts = {};
      try {
        const langModule = await import(
          `../../localeTexts/${lang ?? selectedLang?.selectedLanguage?.toLowerCase() ?? 'en'}`
        );
        texts = langModule?.texts;
      } catch (e) {
        const langModule = await import(`../../localeTexts/en`);
        texts = langModule?.texts;
      }

      dispatch(getSelectedLocaleAction(texts));
    }

    selectLocale();
  }, [dispatch, lang, selectedLang, texts]);

  return <></>;
};
